
App.controller('PrnSignupCtrl', ['$rootScope', '$scope', '$http', 'ngDialog', '$timeout', '$localStorage',
    '$sessionStorage', '$state', 'Api', 'toastr', 'authApi', '$stateParams', '$loading', 'mixPanelApi', 
     '$location', 'organizationService', 'ProfessionalService', 'UsersClientService', 'LicenseService', 'SpecialtyService', 'sessionService',
    function ($rootScope, $scope, $http, ngDialog, $timeout, $localStorage, $sessionStorage,
              $state, Api, toastr, authApi, $stateParams, $loading, mixPanelApi, 
              $location, organizationService, ProfessionalService, UsersClientService, LicenseService, SpecialtyService, sessionService) {
            $scope.user = {
                license: '',
                specialties: []
            };
            $scope.pwdRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{8,}$/;
            $scope.professions = ['Nurse', 'Allied Health'];
            $scope.licenses = [];
            $scope.specialties = [];
            $scope.selectedLicenses = [];
            $scope.selectedSpecialties = ['None'];
            
            this.loadOrganization = async function (key){
                const organization = await organizationService.get(key);
                $scope.organizationName = _.get(organization, 'name');
                $scope.organizationLogo = _.get(organization, 'facility.logoURL');
                $scope.organizationId = _.get(organization, '_id');
                $scope.disclaimer = _.get(organization, 'facility.disclaimer');
                $scope.privacyUrl = _.get(organization, 'facility.privacyUrl');
                $scope.termsUrl = _.get(organization, 'facility.termsUrl');
                $scope.isDisclaimerConfirmed = !($scope.disclaimer && ($scope.termsUrl || $scope.privacyUrl));
                $scope[`organizationNameisDisabled`] = !!$scope.organizationName;
            }

            // load licenses and specialties
            this.loadBriefcaseConstants = async function() {
                LicenseService.list(undefined)
                    .then(licenses => {
                        $scope.licenses = licenses;
                        $scope.$applyAsync();
                    })
                    .catch(e => console.error(e))
                SpecialtyService.list(undefined)
                    .then(specialties => {
                        $scope.specialties = specialties;
                        $scope.$applyAsync();
                    })
                    .catch(e => console.error(e))
            }   

            this.$onInit = async function () {
                $scope.isCoBranded = !!$stateParams.coBrandedKEY;
                $scope.coBrandedKEY = $stateParams.coBrandedKEY;
                const { organization_id, isMarketplace } = $location.$$search;
                if ($location.$$search.email) {
                    $scope.user.email = $location.$$search.email;
                }
                if ($location.$$search.firstName) {
                    $scope.user.firstName = $location.$$search.firstName;
                }
                if ($location.$$search.lastName) {
                    $scope.user.lastName = $location.$$search.lastName;
                }
                const { user_id, token } = $stateParams;
                $scope.token = token;
                $scope.userId = user_id;
                $timeout(() => $loading.start('prnSignUp'));

                if($scope.isCoBranded){
                    try {
                        await this.loadOrganization($stateParams.coBrandedKEY);
                        $scope.user.profession = '';
                        $loading.finish('prnSignUp');
                        $scope.$apply();
                    } catch (e) {
                        toastr.error(e.message);
                    }
                } else {
                    try {
                        const { email, firstName, lastName, phoneNumber, profession, affiliations = [], isMarketplace: marketplace } = await ProfessionalService.get(user_id, { verificationToken: token });
                        $scope.affiliations = affiliations;
                        const isMKP = isMarketplace === 'true' || marketplace;
                        $scope.showAffiliations = affiliations.length > 1 ||
                            (isMKP && affiliations.length) ||
                            (organization_id && _.get(affiliations, '[0].organization._id') !== organization_id);
                        const aff = [...affiliations];
                        if(organization_id){
                            aff.push({ organization: { _id: organization_id }})
                        }
                        const uniqueAffiliations = _.uniqBy(aff, 'organization._id')
                        if(uniqueAffiliations.length === 1){
                            const firstAffiliationId = _.get(uniqueAffiliations, '[0].organization._id')
                            if(!organization_id || firstAffiliationId === organization_id){
                                const { organization } = uniqueAffiliations[0];
                                $scope.organizationName = _.get(organization, 'name');
                                $scope.organizationLogo = _.get(organization, 'facility.logoURL');
                                $scope.organizationId = _.get(organization, '_id');
                                $scope.disclaimer = _.get(organization, 'facility.disclaimer');
                                $scope.privacyUrl = _.get(organization, 'facility.privacyUrl');
                                $scope.termsUrl = _.get(organization, 'facility.termsUrl');
                                $scope[`organizationNameisDisabled`] = !!$scope.organizationName;
                                $scope.isDisclaimerConfirmed = !($scope.disclaimer && ($scope.termsUrl || $scope.privacyUrl));
                            } else {
                                await this.loadOrganization(organization_id);
                            }
                        }
                        if(organization_id && !affiliations.find(({ organization }) => organization._id === organization_id)){
                            const organization = await organizationService.get(organization_id);
                            affiliations.push({ organization });
                        }
                        if(isMKP){
                            $scope.affiliations.push({ organization: { name: 'Praos Health'}});
                        }
                        
                        $scope.user = { email, firstName, lastName, phoneNumber, profession, isMarketplace: isMarketplace === 'true', organizationId: $scope.organizationId };
                        Object.keys($scope.user).forEach((key) => $scope[`${key}isDisabled`] = !!$scope.user[key]);
                        $loading.finish('prnSignUp');
                        $scope.$apply();
                    } catch (e){
                        toastr.error(e.message);
                    }
                }
                // get license & specialties
                this.loadBriefcaseConstants();
            }

            $scope.professionUpdated = function(profession) {
                if (profession) {
                    $scope.selectedLicenses = $scope.licenses.filter(license => license.profession === profession);
                    $scope.selectedSpecialties = ['None'].concat($scope.specialties.filter(specialty => specialty.profession === profession).map(specialty => specialty.name));
                }
                $scope.user.license = '';
                $scope.user.specialties = profession === 'Allied Health'? ['None'] : [];
            }

            // =============to submit form=============
            $scope.submit = async function (valid) {
                if(!valid || !$scope.user.specialties.length){ return; }

                const { isMarketplace } = $location.$$search;
                const organization_id = $scope.organizationId;

                if($scope.isCoBranded){
                    const { firstName, lastName, email, password, phoneNumber, profession, specialties, license } = $scope.user;
                    console.log('user', $scope.user)
                    const payload = {
                        item: {
                            firstName,
                            lastName,
                            email,
                            phoneNumber: phoneNumber ? phoneNumber.replace(/\-/g, '') : undefined,
                            profession,
                            briefcase: {
                                licenses: [{ licenseType: license, isCompact: false }],
                                specialties: specialties.includes('None') ? undefined : specialties
                            }
                        },
                        password
                    };

                    if (organization_id) {
                        payload.organizationId = organization_id;
                    }

                    if (isMarketplace == 'true') {
                        payload.item.isMarketplace = true;
                    }

                    try {
                        $loading.start('prnSignUp');
                        await ProfessionalService.add(payload);
                        $localStorage['coBrandedKEY'] = $stateParams.coBrandedKEY;
                        $scope.signup_message = 'Your email address has been registered. A verification email has been sent to your email account. Please click on the link to verify your address and continue to complete your application.';
                        $timeout(function () {
                            $scope.dialogId = ngDialog.open({
                                template: 'register-popup',
                                className: 'ngdialog-theme-default register-popup',
                                closeByNavigation: true,
                                showClose: false,
                                scope: $scope
                            });
                        }, 100);
                        $loading.finish('prnSignUp');
                    } catch (e){
                        $scope.exist_message = e.message;
                        $loading.finish('prnSignUp');
                        $scope.dialogId = ngDialog.open({
                            template: 'email_exists',
                            className: 'ngdialog-theme-default register-popup',
                            closeByNavigation: true,
                            showClose: false,
                            scope: $scope
                        });
                        $scope.dialogHandler = () => {
                            ngDialog.close($scope.dialogId);
                            if(e.name && !e.name.includes('AddAffiliationRequiredError')){
                                $state.go('coBrandedLogin',{'coBrandedKEY':$stateParams.coBrandedKEY});
                            }
                        }
                    }
                } else {
                    const { password, phoneNumber } = $scope.user;
                    const options = { token: $scope.token, password };

                    if (organization_id) {
                        options.organizationId = organization_id;
                    }

                    if (isMarketplace == 'true') {
                        options.isMarketplace = true;
                    }
                    
                    if(phoneNumber){
                        options.phoneNumber = phoneNumber.replace(/\-/g, '');
                    }

                    try {
                        const newToken = await ProfessionalService.verify($scope.userId, options);
                        $scope.success = 'Your account successfully verified';
                        authApi.setToken(newToken);
                        await sessionService.updateProfessional();
                        await sessionService.updateNotifications();
                        $state.go('splash');
                    }
                    catch (e) {
                        toastr.error(e.message);
                    }
                }
            }

            $scope.resendLink = async function (e) {
                e.preventDefault();
                try {
                    await UsersClientService.resendVerification({ email: $scope.user.email, organizationId: $scope.organizationId });
                    ngDialog.close($scope.dialogId);
                    toastr.success('A verification link has been sent to your email address. Please check your email address.');
                }catch (e){
                    toastr.error(e.message);
                }
            }
            
            /* close Dialogbox function */
            $scope.closeBanner = function () {
                $scope.bannerClose = true;
            }

            $scope.closePopup = function () {
                ngDialog.closeAll();
                if ($scope.isCoBranded) {
                    $state.go('coBrandedLogin',{'coBrandedKEY':$scope.coBrandedKEY});
                } else {
                    $state.go('login');
                }
            }
    }]);